/**
 * Maps backend user.language (e.g. "English", "Spanish") to Google Translate API target codes.
 */
export function mapUserLanguageToCode(languageName) {
  if (!languageName || typeof languageName !== 'string') return 'en';

  const normalized = String(languageName).toLowerCase().trim();

  // If the value already looks like a language code (e.g. "es", "fr", "pt-br"),
  // use it directly so short forms work as-is.
  // Exception: "zh" → use "zh-CN" for Google Translate.
  if (/^[a-z]{2}(-[a-z]{2})?$/.test(normalized)) {
    if (normalized === 'zh') return 'zh-CN';
    return normalized;
  }

  const map = {
    english: 'en',
    español: 'es',
    spanish: 'es',
    العربية: 'ar',
    arabic: 'ar',
    türkçe: 'tr',
    turkish: 'tr',
    french: 'fr',
    français: 'fr',
    german: 'de',
    deutsch: 'de',
    italian: 'it',
    italiano: 'it',
    portuguese: 'pt',
    português: 'pt',
    russian: 'ru',
    русский: 'ru',
    chinese: 'zh-CN',
    hindi: 'hi',
    japanese: 'ja',
    korean: 'ko',
    dutch: 'nl',
    polish: 'pl',
    thai: 'th',
    vietnamese: 'vi',
    indonesian: 'id',
    malay: 'ms',
  };

  return map[normalized] || 'en';
}
